import { useLocation } from "react-router";
import { API_URLS } from "src/api/api-urls";
import useApiServices from "src/api/use-api-services";
import { filtersDefaultValues } from "src/constants/filters-default-values";
import { IActivityItemDto } from "src/types/activities";
import { MediumMainDtoType } from "src/types/platforms/medium";
import { DashboardType } from "src/types/types";
import { isLoadingActivity } from "src/utils/is-loading-activity";
import { useQueryParams } from "use-query-params";

type RouterState = {
  state: {
    activity: IActivityItemDto;
  };
};

const useMediumDashboardView = ({ type }: { type: DashboardType }) => {
  // #region States and hooks
  const { state }: RouterState = useLocation();
  const { useGetListApi } = useApiServices();

  // Get filters default from url params if available
  const [query] = useQueryParams(filtersDefaultValues);
  // #endregion States and hooks

  // #region Services
  // Get charts data and analysis
  const {
    data: platformData,
    isLoading: isDataLoading,
    error,
  } = useGetListApi<MediumMainDtoType>({
    url: API_URLS[type].MEDIUM.ANALYSIS,
    parameters: {
      keyword: query.keyword,
      sentiment: query.sentiment,
      language: query.language,
      start_date: query.start_date,
      end_date: query.end_date,
    },
    enabled: state ? !isLoadingActivity(state.activity) : true,
  });
  // #endregion Services

  return {
    platformData,
    isDataLoading,
    error,
  };
};

export default useMediumDashboardView;
